<!--banner starts-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
               style="background-image: url(../../assets/phonegapbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 20px;">
                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Phonegap Application Development</h1></div>
                    <div>
                        <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">
                            PhoneGap is a platform where you can create apps to operate and run on more than one device without changing the base of.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>       
<!--banner ends-->
<div class="uk-section uk-padding" style=" padding-bottom: 0px;">
    <div class="uk-container">
      
    <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">PhoneGap is an open-source framework, which is used to develop mobile applications. It is an efficient way of creating hybrid mobile applications using HTML5, CSS3, and JavaScript, which eliminates the need to write apps in complex languages like Objective-C and Java. It produces apps for all major mobile platforms such as iOS, Android, BlackBerry, and Windows Mobile OS, etc. It offers a streamlined way to develop an application from scratch.
    </p>

    <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">  
        PhoneGap lead to the creation of robust hybrid apps loaded with features, such as Vibration, GPS, Accelerometer, etc. It enables developers to leverage the best of their development skills and the web technologies to build excellent mobile apps. It has robust backend support which speeds up the development process and reduces the developer’s efforts. They also provide beginners guide for the novice developers to understand the entire project easily.It offers some of the tools and other commendable features which help the developers in a long run
    </p>

    <h2 class="uk-text-center" style="font-weight: 600px;">PhoneGap Application Development Services</h2>
              <br>
              <div class="uk-column-1-2@s">
      
                  
                  <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">It is an open source development framework that enables web developers to build cross platform mobile applications. PhoneGap allows reusing existing web development skills to quickly develop a hybrid application using HTML, CSS, and JavaScript. PhoneGap helps in creating applications for multiple platforms with a single base of code to target a large audience. It is cloud-based and is built on top of the PhoneGap framework that also allows compiling in the cloud.</p>
                       <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">WebSoulLabs takes cross-platform app development to the next level with PhoneGap toolset, plugins, third-party tools, and the framework built-in SDKs.The passion and excellence displayed by PhoneGap developers at WebSoulLabs result in easy, simple and useful mobile, web apps.The PhoneGap apps interact with mobile device hardware unlike the normal mobile applications and supports different mobile apps versions for mobile platforms.
                        </p>
                  <img data-src="assets/phonegap3.png" width="600" height="600" alt="" uk-img>
      
              </div>
            </div>
    <h1 class="uk-text-center" style="margin-bottom: 0px;"><span>Related Services</span></h1>
    <br>
    <div class="uk-container">
        <div class="uk-grid-small  uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                   
                    <img class=" uk-align-center" src="assets/icons/ig1.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight:600">IPhone App<br> Development</h4>
            
                </div>
            </div>
           
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class="uk-border-pill uk-align-center" src="assets/icons/androigg13.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight:600">Android App<br> Development</h4>
                
                
                </div>
            </div>
          
    
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                    <img class=" uk-align-center" src="assets/icons/mobileg1.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight:600">Mobile Application<br> Development</h4>
                </div>
            </div>
    
            <div>
           
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                    <img class=" uk-align-center" src="assets/icons/xamaring10.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight:600">Xamarin App<br> Development</h4>
    
               
                </div>
            </div>
    
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                    <img class=" uk-align-center" src="assets/icons/cross.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight:600">Cross Platform App Development</h4>
    
               
                </div>
            </div>
    
           
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium"  style="padding-top: 30px;">
                    <img class=" uk-align-center" src="assets/icons/swiftg9.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight:600">Swift App<br> Development</h4>
    
                </div>
            </div>
           
        </div>
       
       

    </div>

</div>
<br><br>
    <br>

    <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br><br>
    
    <div class="uk-container">
        
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
   
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/and.png" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Android</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/apple.png" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Ios</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/kotlin.jpg" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Kotlin</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/Fabric.jpg" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Fabric</h4>
                </div>
            </div>
        </div>
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/xamarin.png" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Xamarin</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/React.webp" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">React JS</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/java.jpg" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Java</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/swi.jpg" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Swift</h4>
                </div>
            </div>
        </div>
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/appt.png" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Appcelerator Titanium</h4>
                </div>
            </div>
            <div>
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/back.png" width="140" height="140"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Backbone</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-pill uk-align-center" src="assets/ember.png" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Ember</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/flutter.png" width="100" height="100"
                        alt="Border pill">
                        <h4  style="font-weight: 600;">Flutter</h4>
                </div>
            </div>
        </div>
    </div>
<br><br>
<br>
    
    
